export const environment = {
  production: true,
  // developmentUrl: 'https://devhrisapi.phiedge.co.in/',
  // downloadURL: 'https://phiedgehriss3.s3.ap-south-1.amazonaws.com/',
  developmentUrl: 'https://hrisapi.phiedge.co.in/',
  // developmentUrl: 'https://uathrisapi.phiedge.co.in/',
  downloadURL: 'https://phiedgehriss3.s3.ap-south-1.amazonaws.com/'
};
